import { useEffect, useState } from "react";
import fetchData from "../../../shared/fetchData";
import Button from "../../UI/Button/Button";
import ContentForm from "../../UI/ContentForm/ContentForm";
import SelectBox from "../../UI/Select/Select";
import Spinner from "../../UI/Spinner/Spinner";
import "../ClientVideo.css";

const ClientVideoKiosks = (props) => {
    const [loading, setLoading] = useState(false);
    const [isGlobal, setIsGlobal] = useState(false);
    const [bunches, setBunches] = useState([]);
    const [selectedBunch, setSelectedBunch] = useState("");
    const [bunchKiosks, setBunchKiosks] = useState([]);
    const [selectedKiosks, setSelectedKiosks] = useState([]);
    const [kioskSelectionError, setKioskSelectionError] = useState(false);
    const [rerender, setRerender] = useState(false);

    const resolveKioskMeta = (kioskId, bunchesList) => {
        let meta = { id: kioskId, description: String(kioskId), bunchId: "", bunchName: "" };
        bunchesList.forEach((bunch) => {
            const kiosk = bunch.kiosks?.find((k) => String(k.id) === String(kioskId));
            if (!!kiosk) {
                meta = {
                    id: kiosk.id,
                    description: kiosk.description,
                    bunchId: bunch.id,
                    bunchName: bunch.description,
                };
            }
        });
        return meta;
    };

    const buildSelectedFromVideo = (video, bunchesList) => {
        if (!!video?.kiosks && video.kiosks.length > 0) {
            return video.kiosks.map((kiosk) => {
                const fromBunch = resolveKioskMeta(kiosk.id, bunchesList);
                return {
                    id: kiosk.id,
                    description: kiosk.description || fromBunch.description,
                    bunchId: fromBunch.bunchId,
                    bunchName: fromBunch.bunchName,
                };
            });
        }
        if (!!video?.kioskIds && video.kioskIds.length > 0) {
            return video.kioskIds.map((id) => resolveKioskMeta(id, bunchesList));
        }
        return [];
    };

    useEffect(() => {
        setLoading(true);
        var raw = JSON.stringify({ pl: "10000", pn: "1", version: "mtpx001" });
        var url = "management/api/v1/bunches/getBunches";
        fetchData(raw, url)
            .then((response) => response.json())
            .then((result) => {
                const list = result.status == 0 ? (result.bunches || []) : [];
                setBunches(list);
                setSelectedKiosks(buildSelectedFromVideo(props.clientVideo, list));
                const video = props.clientVideo || {};
                setIsGlobal(
                    video.isGlobal === true ||
                    video.isGlobal === 'true' ||
                    video.isGlobal === 1 ||
                    video.isGlobal === '1'
                );
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [props.clientVideo]);

    const bunchChangeHandler = (value) => {
        setSelectedBunch(value);
        if (!!value) {
            const bunch = bunches.find((b) => b.id === value.value);
            setBunchKiosks(bunch?.kiosks || []);
        } else {
            setBunchKiosks([]);
        }
    };

    const isKioskSelected = (kioskId) => {
        return selectedKiosks.some((k) => String(k.id) === String(kioskId));
    };

    const chooseKiosk = (kiosk) => {
        if (isKioskSelected(kiosk.id)) {
            setSelectedKiosks(selectedKiosks.filter((k) => String(k.id) !== String(kiosk.id)));
        } else {
            setSelectedKiosks([
                ...selectedKiosks,
                {
                    id: kiosk.id,
                    description: kiosk.description,
                    bunchId: selectedBunch.value,
                    bunchName: selectedBunch.label,
                },
            ]);
        }
        setKioskSelectionError(false);
        setRerender(!rerender);
    };

    const removeSelectedKiosk = (kioskId) => {
        setSelectedKiosks(selectedKiosks.filter((k) => String(k.id) !== String(kioskId)));
        setKioskSelectionError(false);
    };

    const clearAllSelectedKiosks = () => {
        setSelectedKiosks([]);
        setKioskSelectionError(false);
    };

    const isGlobalChangeHandler = (event) => {
        const checked = event.target.checked;
        setIsGlobal(checked);
        if (checked) {
            setKioskSelectionError(false);
        }
    };

    const submitKiosks = () => {
        if (!isGlobal && selectedKiosks.length === 0) {
            setKioskSelectionError(true);
            return;
        }
        setLoading(true);
        const kioskIds = selectedKiosks.map((k) => k.id);
        var raw = JSON.stringify({
            video: {
                id: props.clientVideo.id,
                isGlobal: isGlobal,
                kioskIds: isGlobal ? [] : kioskIds,
            },
            version: "mtpx001",
        });
        var url = "management/api/v1/clientvideos/updateClientVideoKiosks";
        fetchData(raw, url)
            .then((response) => response.json())
            .then((result) => {
                setLoading(false);
                if (result.status == "0" || result.status == 0) {
                    if (props.onSaved) {
                        props.onSaved();
                    } else {
                        props.back();
                    }
                }
            })
            .catch(() => setLoading(false));
    };

    let bunchList = [];
    if (bunches != null && bunches.length !== 0) {
        bunches.map((b) => {
            bunchList.push({
                value: b.id,
                label: b.description,
            });
        });
    }

    const selectedKioskChips = selectedKiosks.map((kiosk) => (
        <div key={kiosk.id} className="video-kiosk-chip">
            <div className="video-kiosk-chip-content">
                <span className="video-kiosk-chip-name">{kiosk.description}</span>
                <span className="video-kiosk-chip-bunch">{kiosk.bunchName}</span>
            </div>
            <button
                type="button"
                className="video-kiosk-chip-remove"
                onClick={() => removeSelectedKiosk(kiosk.id)}
                title="حذف"
            >
                ×
            </button>
        </div>
    ));

    const kioskPickerItems = bunchKiosks.map((kiosk) => {
        const selected = isKioskSelected(kiosk.id);
        return (
            <div
                key={kiosk.id}
                className={`video-kiosk-picker-item ${selected ? "video-kiosk-picker-item-selected" : ""}`}
                onClick={() => chooseKiosk(kiosk)}
            >
                <div className="video-kiosk-picker-check">
                    {selected ? "✓" : ""}
                </div>
                <div className="video-kiosk-picker-info">
                    <div className="video-kiosk-picker-name">{kiosk.description}</div>
                    {kiosk.address ?
                        <div className="video-kiosk-picker-address">{kiosk.address}</div>
                        : ""}
                </div>
            </div>
        );
    });

    return (
        <div className="row justify-content-center">
            {loading ? <Spinner /> : ""}
            <div className="video-cntnr">
                <ContentForm headetText={`لاکرهای ویدئو: ${props.clientVideo?.videoName || ""}`}>
                    <div className="row justify-content-center w-100 m-0 mt-3">
                        <div className="video-frm">
                            <div className="video-target-section">
                                <div className="video-section-title">محدوده نمایش ویدئو</div>

                                <div className={`video-global-card ${isGlobal ? 'video-global-card-active' : ''}`}>
                                    <label className="video-global-checkbox-simple">
                                        <input
                                            type="checkbox"
                                            className="video-global-checkbox-simple-input"
                                            onChange={isGlobalChangeHandler}
                                            checked={isGlobal}
                                        />
                                        <span className="video-global-checkbox-simple-text">
                                            نمایش روی همه ی لاکر ها
                                        </span>
                                    </label>
                                    <div className="video-global-checkbox-simple-hint">
                                        با انتخاب این گزینه، این ویدئو روی همه لاکرها نمایش داده می‌شود.
                                    </div>
                                </div>

                                {!isGlobal ?
                                    <div className="video-kiosk-target-panel">
                                        <div className="video-selected-panel">
                                            <div className="video-selected-panel-header">
                                                <div>
                                                    <span className="video-selected-panel-title">لاکرهای انتخاب‌شده</span>
                                                    <span className="video-selected-count">{selectedKiosks.length} مورد</span>
                                                </div>
                                                {selectedKiosks.length > 0 ?
                                                    <button
                                                        type="button"
                                                        className="video-clear-all-btn"
                                                        onClick={clearAllSelectedKiosks}
                                                    >
                                                        پاک کردن همه
                                                    </button>
                                                    : ""}
                                            </div>
                                            <div className="video-selected-panel-body">
                                                {selectedKiosks.length > 0 ?
                                                    <div className="video-kiosk-chips">
                                                        {selectedKioskChips}
                                                    </div>
                                                    :
                                                    <div className="video-selected-empty">
                                                        هنوز لاکری انتخاب نشده است. از بخش پایین، خوشه و لاکر مورد نظر را اضافه کنید.
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className="video-picker-panel">
                                            <div className="video-picker-step">
                                                <span className="video-picker-step-number">۱</span>
                                                <span className="video-picker-step-label">انتخاب خوشه</span>
                                            </div>
                                            <SelectBox
                                                name="video-bunch-select-edit"
                                                value={selectedBunch}
                                                placeholder="خوشه مورد نظر را انتخاب کنید"
                                                options={bunchList}
                                                onChange={bunchChangeHandler}
                                                col="12"
                                            />

                                            {!!selectedBunch ?
                                                <>
                                                    <div className="video-picker-step video-picker-step-second">
                                                        <span className="video-picker-step-number">۲</span>
                                                        <span className="video-picker-step-label">
                                                            انتخاب لاکر از خوشه «{selectedBunch.label}»
                                                        </span>
                                                    </div>
                                                    {bunchKiosks.length > 0 ?
                                                        <div className="video-kiosk-picker-list">
                                                            {kioskPickerItems}
                                                        </div>
                                                        :
                                                        <div className="video-kiosk-empty">
                                                            لاکری برای این خوشه یافت نشد.
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <div className="video-picker-hint">
                                                    برای افزودن لاکر، ابتدا یک خوشه را انتخاب کنید.
                                                </div>
                                            }
                                        </div>

                                        {kioskSelectionError ?
                                            <div className="video-kiosk-error">
                                                لطفا حداقل یک لاکر انتخاب کنید یا گزینه «نمایش روی همه لاکرها» را فعال کنید.
                                            </div>
                                            : ""}
                                    </div>
                                    : ""}
                            </div>

                            <div className="row justify-content-center m-0 w-100 mt-4 video-form-actions">
                                <div className="col-4">
                                    <Button btnType="Success" clicked={submitKiosks}>ذخیره</Button>
                                </div>
                                <div className="col-4">
                                    <Button btnType="General" clicked={props.back}>برگشت</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentForm>
            </div>
        </div>
    );
};

export default ClientVideoKiosks;
